module.exports = __webpack_public_path__ + "m.no1.c6fa9a9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/m.no1.jpg
// module id = 8EQ+
// module chunks = 0